// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"947":"3da8de5e169d0359","5507":"db19a8d6348d02a8","9791":"0bd9ffd88332afe7"}[chunkId] + ".css";
};